module.exports = __webpack_public_path__ + "img/no-lose.ef5e7643.svg";